import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { tariffesArraySelector, userSelector } from "../../store/selectors";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import plusIcon from "../../assets/plus-icon.svg";
import "./AdminStatsScreen.css";
import momentTz from "moment-timezone";
import ProfileSidebar from "../../components/ProfileSidebar/ProfileSidebar";
import Avatar from "../../components/Avatar/Avatar";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AppLogo from "../../assets/AppLogoBlue.svg";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";
import {
  deleteTariff,
  fetchLatestStats,
  fetchMetricData,
  fetchOrganizationsTariffes,
  fetchTariffes,
} from "../../store/tariffesSlice";
import AddTariffModal from "../../components/AddTariffModal/AddTariffModal";
import EditTariffModal from "../../components/EditTariffModal/EditTariffModal";
import TariffVersionsModal from "../../components/TariffVersionsModal/TariffVersionsModal";
import OrganizationChangeTariffModal from "../../components/OrganizationChangeTariffModal/OrganizationChangeTariffModal";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import { Chart } from "react-charts";

const eternalTariffesIds = [8, 19, 21];

const AdminStatsScreen = () => {
  const user = useSelector(userSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { logout } = useAuth();
  const [activeTab, setActiveTab] = useState("TOTAL_USERS");
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [metricsData, setMetricsData] = useState({
    TOTAL_USERS: [],
    TOTAL_UPLOADED_VIDEOS: [],
    TOTAL_STORAGE_USED_MB: [],
    TOTAL_VIDEO_DURATION_SEC: [],
    TOTAL_COMMENTS: [],
    TOTAL_ACTIVE_SUBSCRIPTIONS: [],
  });
  const userName = user?.email;
  const [statsArray, setStatsArray] = useState([]);

  const metricLabel = {
    TOTAL_USERS: "Всего пользователей",
    TOTAL_UPLOADED_VIDEOS: "Всего загружено видео",
    TOTAL_STORAGE_USED_MB: "Текущий объем используемого хранилища",
    TOTAL_VIDEO_DURATION_SEC: "Общая длительность видео",
    TOTAL_COMMENTS: "Всего комментариев",
    TOTAL_ACTIVE_SUBSCRIPTIONS: "Всего активных подписок",
  };

  useEffect(() => {
    updateInfo();
  }, []);

  const updateInfo = async () => {
    const fromDate = "2025-10-07";
    const toDate = "2025-11-24";
    // const metricsTypes = [
    //   "TOTAL_USERS",
    //   "TOTAL_UPLOADED_VIDEOS",
    //   "TOTAL_STORAGE_USED_MB",
    //   "TOTAL_VIDEO_DURATION_SEC",
    // ];

    const newMetricsData = {
      TOTAL_USERS: 0,
      TOTAL_UPLOADED_VIDEOS: 0,
      TOTAL_STORAGE_USED_MB: 0,
      TOTAL_VIDEO_DURATION_SEC: 0,
      TOTAL_COMMENTS: 0,
      TOTAL_ACTIVE_SUBSCRIPTIONS: 0,
    };

    for (let i = 0; i < Object.keys(newMetricsData).length; i++) {
      const metricCode = Object.keys(newMetricsData)[i];
      const res = await dispatch(
        fetchMetricData({
          fromDate,
          toDate,
          metricCode,
        })
      );
      if (!res.error) {
        const originalArray = res.payload;
        const onlyNoOrg = originalArray
          // .filter(
          //   (item) => !item.organizationId && item.createdBy === "anonymous"
          // )
          .map((item) => ({
            ...item,
            date: item.date.substr(8, 2) + "." + item.date.substr(5, 2),
            value:
              metricCode === "TOTAL_STORAGE_USED_MB"
                ? +item.value.toFixed(2)
                : metricCode === "TOTAL_VIDEO_DURATION_SEC"
                  ? +(item.value / 1000).toFixed(0)
                  : item.value,
          }));
        newMetricsData[metricCode] = onlyNoOrg;
        console.log(`[${metricCode}]:`, onlyNoOrg);
      }
    }
    setMetricsData(newMetricsData);
  };

  const formatDate = (dateString) => {
    const res = momentTz(dateString).tz("etc/gmt-3").format("DD.MM.YYYY");
    return res;
  };

  const getTotalMetricCount = (valuesArray) => {
    if (valuesArray.length === 0) return 0;
    if (activeTab === "TOTAL_USERS") {
      return valuesArray[valuesArray.length - 1].value;
    }
    if (activeTab === "TOTAL_UPLOADED_VIDEOS") {
      return valuesArray[valuesArray.length - 1].value;
    }

    if (activeTab === "TOTAL_ACTIVE_SUBSCRIPTIONS") {
      return valuesArray[valuesArray.length - 1].value;
    }

    if (activeTab === "TOTAL_STORAGE_USED_MB") {
      const valueInMb = valuesArray[valuesArray.length - 1].value;
      let result = valueInMb;

      if (valueInMb > 1024) {
        result = (valueInMb / 1024).toFixed(3).toString() + " Гб";
      } else {
        result += " Мб";
      }

      return result;
    }

    if (activeTab === "TOTAL_VIDEO_DURATION_SEC") {
      const valueInSeconds = valuesArray[valuesArray.length - 1].value;
      let result = valueInSeconds;

      if (valueInSeconds > 3600) {
        let numberOfHours = Math.floor(+valueInSeconds / 3600);
        let secondsLeft = Math.floor(+valueInSeconds - 3600 * numberOfHours);
        let numberOfMinutes = Math.floor(+secondsLeft / 60);
        let numberOfSeconds = Math.floor(+secondsLeft - 60 * numberOfMinutes);

        result = `${numberOfHours} ч. ${numberOfMinutes} мин. ${numberOfSeconds} сек.`;
      } else if (valueInSeconds > 60) {
        let numberOfMinutes = Math.floor(+valueInSeconds / 60);
        let numberOfSeconds = Math.floor(
          +valueInSeconds - 60 * numberOfMinutes
        );
        result = `${numberOfMinutes} мин. ${numberOfSeconds} сек.`;
      } else {
        result += " сек.";
      }

      return result;
    }

    if (activeTab === "TOTAL_COMMENTS") {
      return valuesArray[valuesArray.length - 1].value;
    }
  };

  const yesterdayDate = formatDate(
    momentTz().subtract(1, "days").toISOString()
  );

  return (
    <div className="adminScreen-App">
      {/* HEADER */}
      <div className={"adminScreen-header"}>
        <div className="header-left">
          <div
            onClick={() => navigate("/home", { replace: true })}
            className={"mainScreen-logoBlock"}
            style={{ cursor: "pointer" }}
          >
            <img src={AppLogo} style={{ height: "80%" }} alt="logo" />
          </div>
        </div>
        <div className="header-actions">
          <NotificationsPopup />
          <ProfilePopup />
        </div>
      </div>
      <div className="admin-container" style={{ alignItems: "flex-start" }}>
        <ProfileSidebar activeTab="admin" subActive="stats" />
        {/* <aside className="admin-sidebar">
          <nav>
            <ul>
              <li className="active">Дашборд</li>
            </ul>
            <ul onClick={() => navigate("/profile/admin/tariffes")}>
              <li className="">Тарифы</li>
            </ul>
            <ul onClick={() => navigate("/profile/admin/organizations")}>
              <li>Организации</li>
            </ul>
          </nav>
        </aside> */}
        <main className="admin-main">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <h1 className="admin-title">Дашборд</h1>
          </div>
          <Tabs
            value={activeTab}
            style={{ color: "white", marginTop: 20 }}
            onChange={(e, newValue) => setActiveTab(newValue)}
            aria-label="basic tabs example"
          >
            <Tab
              style={{
                color: "white",
                fontFamily: "NT Somic",
                fontWeight: 400,
              }}
              label="Пользователи"
              value={"TOTAL_USERS"}
            />
            <Tab
              style={{
                color: "white",
                fontFamily: "NT Somic",
                fontWeight: 400,
              }}
              label="Загруженные видео"
              value={"TOTAL_UPLOADED_VIDEOS"}
            />
            <Tab
              style={{
                color: "white",
                fontFamily: "NT Somic",
                fontWeight: 400,
              }}
              label="Хранилище"
              value={"TOTAL_STORAGE_USED_MB"}
            />
            <Tab
              style={{
                color: "white",
                fontFamily: "NT Somic",
                fontWeight: 400,
              }}
              label="Длительность видео"
              value={"TOTAL_VIDEO_DURATION_SEC"}
            />
            <Tab
              style={{
                color: "white",
                fontFamily: "NT Somic",
                fontWeight: 400,
              }}
              label="Комментарии"
              value={"TOTAL_COMMENTS"}
            />
            <Tab
              style={{
                color: "white",
                fontFamily: "NT Somic",
                fontWeight: 400,
              }}
              label="Подписки"
              value={"TOTAL_ACTIVE_SUBSCRIPTIONS"}
            />
          </Tabs>
          <span className="admin-stats-text">
            {`${metricLabel[activeTab]}`} (по состоянию на {yesterdayDate}):{" "}
            <b>{getTotalMetricCount(metricsData[activeTab])}</b>
          </span>
          <LineChart
            style={{
              width: 600,
              height: 300,
              marginTop: 20,
            }}
            responsive
            data={metricsData[activeTab]}
          >
            <CartesianGrid stroke="#FFFFFF10" strokeDasharray="5 5" />
            <Line dataKey={"value"} />
            <XAxis
              padding={{ top: 10 }}
              style={{ fontSize: 12, marginTop: 10 }}
              dataKey="date"
            />
            <YAxis
              dataKey="value"
              allowDecimals={false}
              domain={([dataMin, dataMax]) => {
                if (activeTab === "TOTAL_USERS") return [0, 70];
                const min = dataMin - 0.01 * dataMin;
                const max = dataMax + 0.01 * dataMax;
                return [min, max];
              }}
            />
            <Tooltip />
          </LineChart>
        </main>
      </div>
    </div>
  );
};

export default AdminStatsScreen;
